import { makeStyles } from "@material-ui/core";

export const useSpacesStyles = makeStyles(() => ({
    title: {
        paddingBottom: 4,
        fontWeight: 700
    }
}));
